import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { FormGroup, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RowClickedEvent } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {KeyValue, Location} from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { UserService } from 'src/app/_services/user.service';
import { MenusService } from 'src/app/_services/menu.service';
import { connect } from 'http2';
import { CustomerService } from '../customer-service';
import { PiiFormService } from 'src/app/_services/pii-form.service';
import Swal from 'sweetalert2';
import {ModalComponent} from "../../../../common/modal/modal.component";
import {ModalConfig} from "../../../../common/modal/modal.config";
import { HttpClient } from '@angular/common/http';
import { DocumentViewerModalComponent } from '../../../../common/document-viewer-modal.component';
const {defaultCountry} = environment;

const MIME_BY_EXT: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};


interface Dictionary {
  [index: string]: string
}

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.scss']
})
export class CustomerEditComponent implements OnInit {
  @ViewChild('kycFileViewModal') private kycFileViewModal: ModalComponent;
  @ViewChild('kycUploadModal') private kycUploadModal: ModalComponent;
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalKycReportCustomer') private modalKycReportComponent: ModalComponent;
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();


  eidFrontViewForm: FormGroup


  EidEncryptedImageUrl:any    /// get the ecrnypted image url from the back end server   you dont need any form just pass the encryptede url here

  public permissions: any = '';
  modalConfigReport: ModalConfig;
  modalKycReport : ModalConfig;
  reviewFlag : any;
  isInitiateKycFlag : boolean ;
  isSubmittedKycFlag : boolean;
  saveReviewFlag:any;
  image : any;
  // imageFile : any = './assets/images/secure.png';
  imageFile : any;
  mindatadis: boolean = true;
  loading: boolean = false;

  profileData :any
  addedBy:any
  customerForm: FormGroup
  Resultdata: any;
  param1: any;
  fname: any;
  mobile: any
  emailId: any
  eid: any
  emiratesExpiry: any
  edcMobile: any
  nationality: any
  dob: any
  gender: any
  passportNumber: any
  passportType: any
  passportExpiry: any
  occupation: any
  pob: any
  emirate: any
  poBox: any
  city: any
  areaDesc: any
  documentType: any
  kycType : any
  address: any

  relavent : any;
  notRelavent :any;
  remark:any;
  finalRelavency : any


  status: any
  remarkData: any

  mid: any
  userId : any

  emiratesIdImage: any
  emiratesIdBackImage: any
  documentInfos: { documentType: string; documentPath: string }[] = [];
  idbioLivenessResponse: any
  idbioFaceMatchResponse: any
  kycResponse: any
  icpDocumentReport: any
  efrDocumentReport:any
  screeningReportPdf: any
  uaePassEid : any
  uaePassPP : any
  uaePassVisa : any
  poa:any


  // Customer Profile Variables
  screeningId : any
  fullname : any
  IdenfoGender : any
  dateOfBirth :any
  countryOfResidence:any
  residenceStatus : any
  recordLastUpdated: any
  deliveryChannel : any

  //Customer Name Screening Variables
  sanctionHit: boolean
  sanctionHitClass : any
  sanctionHitColor : any

  pepHit: boolean
  pepHitClass: any
  pepHitColor:any

  specialInterestHit: boolean
  specialInterestHitClass: any
  specialInterestHitColor: any

  adverseMediaHit: boolean
  adverseMediaHitClass: any
  adverseMediaHitColor: any

  selfDeclaredHit: boolean
  selfDeclaredHitClass: any
  selfDeclaredHitColor: any

  riskRatingHit: any
  riskRatingHitClass: any
  riskRatingHitColor: any

  enforcementHit: any
  enforcementHitClass: any
  enforcementHitColor: any

  isSelfPepHit: any
  isSelfPepHitClass: any
  isSelfPepHitColor: any


  //Risk Factor
  countryOfResidenceRisk : any
  countryOfResidenceScore : any
  countryOfResidenceLevel : any

  deliveryChannelRisk : any
  deliveryChannelScore : any
  deliveryChannelLevel: any

  industryRisk: any
  industryScore: any
  industryLevel :any

  nationalityRisk: any
  nationalityScore: any
  nationalityLevel: any

  productRisk: any
  productScore: any
  productLevel: any

  stateRisk: any
  stateScore: any
  stateLevel: any

  baseRatingRisk: any


  suspiciousActivityReportsRisk: any
  suspiciousActivityReportsScore: any
  suspiciousActivityReportsLevel: any

  nonResidentRisk: any
  nonResidentScore: any
  nonResidentLevel: any

  residenceCountryIsSanctionedRisk: any
  residenceCountryIsSanctionedScore: any
  residenceCountryIsSanctionedLevel: any


  nameScreeningHitSanction : String[]
  nameScreeningHitPep : Boolean
  nameScreeningHitSpecialInterest : any
  nameScreeningHitAdverseMedia : Boolean
  nameScreeningHitDetermination: String

  sanctionScore : any;
  sanctionLevel : any;
  baseRatingLevel : any
  overAllRating :any

  datatableDob: any
  datatableNationality : any

  na : any

  nameScreeningHitsLength: number;
  nameScreeningHitsData: any;
  associations : any[];
  mediaData : any[];
  fieldsData : any[];
  screeningConfig : any = {
    matchScore:0,
    rcaSearch: false,
    aliasSearch: false,
    searchList: []
  };
  onboardedBy : any;

  nameScreeningRemarkData :any;
  nameScreeningRemarkLength : any;
  nameScreeningRelevant: any;
  nameScreeningComments: any;

  map : Map<string, any>;
  isShowInitiate :  boolean;
  saveFlag:boolean;
  keywordList : any[];
  dummyImage : any = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRD4FE0yuWmNBJVLqgk1zdrR8yqqGaD-ixsbDcAfreV44qN5dKgBU3F6OgpIwEYBVs2RWI&usqp=CAU";
  kycUploadModalConfig: ModalConfig;
  kycViewModalConfig: ModalConfig;

  @Input() mobileNumber: String = "";
  selectedTab: number=0;

  constructor(private router: Router,private modalService : NgbModal,private customerOldService: MerchantService, private route: ActivatedRoute, private domSanitizer: DomSanitizer,private alertService : AlertService,private userService:UserService,private menuService: MenusService,private location:Location,private customerService : CustomerService,private sanitizer: DomSanitizer, private http: HttpClient,private piiFormService: PiiFormService) { }

  async ngOnInit() {
    const self = this;
    this.kycUploadModalConfig = {
      modalTitle: "customer",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer KYC Report",
      modalSize: 'xl',
      css: "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalKycReport = {
      modalTitle: "Customer KYC Document",
      modalSize: 'xl',
      css: "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.kycViewModalConfig = {
      modalTitle: "Customer File",
      modalSize: 'sm',
      fullscreen: true,

      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      },
      onClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onTopClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onDismiss(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      }
    }

    this.isInitiateKycFlag = false;
    this.isSubmittedKycFlag = false;
    this.isShowInitiate = false;
    this.saveFlag = false;
    this.nameScreeningHitsData = [];

    // const path = this.location.prepareExternalUrl(this.location.path());
    // this.permissions = this.menuService.getPermissions(path);
    // if (this.permissions == null || this.permissions == '' || !this.permissions) {
    //   this.alertService.errorAlert({
    //     title: "No Access",
    //     backdrop: true,
    //     toast: true,
    //     timer: 1500
    //   })
    //   await this.router.navigateByUrl('/');
    // }

    this.mid = this.route.snapshot.queryParamMap.get("mid");
    this.recordLastUpdated = this.route.snapshot.queryParamMap.get("date");
    this.userId = this.route.snapshot.queryParamMap.get("userId");
    this.customerService.getCustomerScreeningResponseById(this.mid).subscribe((res: any) => {
      console.log("Review Flag :" +res?.response?.data?.reviewFlag);
      this.reviewFlag = res?.response?.data?.reviewFlag;
      this.screeningConfig = res?.response?.data?.screeningUserTypeConfiguration;
      this.onboardedBy = res?.response?.data?.onboardedBy;
      console.log(this.screeningConfig);
      console.log(this.reviewFlag);
      console.log(this.permissions);
      if(this.permissions == "Maker Review" && this.reviewFlag == 0){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 1;
        this.isShowInitiate = false;


      }else if (this.permissions == "Maker Review" && this.reviewFlag == 1){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 2;
        this.isShowInitiate= true;
        this.saveFlag = true;

      }else if(this.permissions == "Checker Review" && this.reviewFlag == 2){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 3;
        this.isShowInitiate= false;

      }else if(this.permissions == "Checker Review" && this.reviewFlag == 3){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 4;
        this.isShowInitiate= true;
        this.saveFlag = true;

      }

      console.log(res.response.data);
      // console.log("screeningId : "+res.response.data.data.data.idenfoId+" Fullname : "+res.response.data.data.data.firstName);
      this.getActivityTimeline(res?.response?.data?.screeningId);
      this.screeningId = res?.response?.data?.screeningId;
      this.fullname =res?.response?.data?.fullName;
      this.countryOfResidence = defaultCountry;

      this.residenceStatus = "Rent";
      if(res?.response?.data?.data != null){
        if(res.response.data.data.data.accountInfo){
          this.deliveryChannel = res.response.data.data.data.accountInfo.registrationChannel[0].title;
          console.log("isSelfPepHit : "+res.response.data.data.data.isSelfPepHit);
          this.isSelfPepHit = res.response.data.data.data.isSelfPepHit;
        }
        if(res.response.data.data.data.kycSummary){
          this.sanctionHit = res.response.data.data.data.kycSummary.nameScreening.sanctionHit;
          this.pepHit = res.response.data.data.data.kycSummary.nameScreening.pepHit;
          this.adverseMediaHit = res.response.data.data.data.kycSummary.nameScreening.adverseMediaHit;
          this.riskRatingHit = res.response.data.data.data.kycSummary.riskRating;
          this.enforcementHit = res.response.data.data.data.kycSummary.enforcementHit;
        }

      }



      this.customerService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
        console.log("Name Screening Remark : "+JSON.stringify(res.response.data));
        this.getSavedNameScreeningLength=res.response.data.length;
        console.log("Name Screening Remark Length : "+res.response.data.length);
        this.map = new Map();
        for(var i=0;i<res.response.data.length;i++){
          this.map.set(res.response.data[i].referenceId, res.response.data[i])
        }
      });



      console.log("sanction Hit : "+this.sanctionHit);
      if(this.sanctionHit){
        this.sanctionHitClass = "feather icon-x-circle";
        this.sanctionHitColor = "color: red;"
      }else{
        this.sanctionHitClass = "feather icon-check";
        this.sanctionHitColor = "color: green;"
      }

      if(this.pepHit){
        this.pepHitClass = "feather icon-x-circle";
        this.pepHitColor= "color: red;"
      }else{
        this.pepHitClass = "feather icon-check";
        this.pepHitColor= "color: green;"
      }

      if(this.adverseMediaHit){
        this.adverseMediaHitClass = "feather icon-x-circle";
        this.adverseMediaHitColor= "color: red;"
      }else{
        this.adverseMediaHitClass = "feather icon-check";
        this.adverseMediaHitColor= "color: green;"
      }

      if(this.riskRatingHit=="sanction"){
        this.riskRatingHit = "Sanctioned";
        this.riskRatingHitClass = "feather icon-x-circle";
        this.riskRatingHitColor= "color: red;"
      }else{
        this.riskRatingHit = "Low";
        this.riskRatingHitClass = "feather icon-check";
        this.riskRatingHitColor= "color: green;"
      }

      if(this.enforcementHit){
        this.enforcementHitClass = "feather icon-x-circle";
        this.enforcementHitColor= "color: red;"
      }else{
        this.enforcementHitClass = "feather icon-check";
        this.enforcementHitColor= "color: green;"
      }

      if(this.isSelfPepHit == "low" || this.isSelfPepHit == "" || this.isSelfPepHit == undefined){
        this.isSelfPepHitClass = "feather icon-check";
        this.isSelfPepHitColor= "color: green;"
      }else{
        this.isSelfPepHitClass = "feather icon-x-circle";
        this.isSelfPepHitColor= "color: red;"
      }

      console.log("Sanction Hit : "+this.sanctionHitColor+this.pepHit+this.adverseMediaHit+this.riskRatingHit);
      if(res?.response?.data?.data != null){

        console.log(res.response.data.data.data.riskRatings);
      if(res.response.data.data.data.riskRatings && res.response.data.data.data.riskRatings.length>=18){
      this.countryOfResidenceScore = res.response.data.data.data.riskRatings[0].number;
      this.countryOfResidenceLevel = res.response.data.data.data.riskRatings[0].level+" Risk";

      this.deliveryChannelScore = res.response.data.data.data.riskRatings[3].number;
      this.deliveryChannelLevel = res.response.data.data.data.riskRatings[3].level+" Risk";

      this.industryScore = res.response.data.data.data.riskRatings[6].number;
      this.industryLevel = res.response.data.data.data.riskRatings[6].level+" Risk";

      this.nationalityScore = res.response.data.data.data.riskRatings[8].number;
      this.nationalityLevel = res.response.data.data.data.riskRatings[8].level+" Risk";

      this.productScore = res.response.data.data.data.riskRatings[10].number;
      this.productLevel = res.response.data.data.data.riskRatings[10].level+" Risk";

      this.stateScore = res.response.data.data.data.riskRatings[11].number;
      this.stateLevel = res.response.data.data.data.riskRatings[11].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.data.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.data.data.riskRatings[12].level+" Risk";

      this.nonResidentScore = res.response.data.data.data.riskRatings[13].overRideTo;
      this.nonResidentLevel = res.response.data.data.data.riskRatings[13].level+" Risk";

      this.residenceCountryIsSanctionedScore = res.response.data.data.data.riskRatings[14].overRideTo;
      this.residenceCountryIsSanctionedLevel = res.response.data.data.data.riskRatings[14].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.data.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.data.data.riskRatings[12].level+" Risk";

      this.sanctionScore = res.response.data.data.data.riskRatings[17].overRideTo;
      this.sanctionLevel = res.response.data.data.data.riskRatings[17].level+" Risk";

      if(this.sanctionScore == "sanction"){
        this.sanctionScore = "Sanctioned";
        this.sanctionLevel = "Sanctioned"
      }else{
        this.sanctionScore = "Low Risk";
        this.sanctionLevel = "Low Risk"
      }

      this.baseRatingLevel =  res.response.data.data.data.kycSummary.riskLevel+" Risk";

      this.overAllRating =  res.response.data.data.data.kycSummary.riskRating;
      if(this.overAllRating == "sanction"){
        this.overAllRating = "Sanctioned";
      }else{
        this.overAllRating = "Low Risk";
      }
      }
      console.log("length : "+res.response.data.data.data.nameScreeningHits.length);

      this.nameScreeningHitsData = res.response.data.data.data.nameScreeningHits;
      this.nameScreeningHitsLength = res.response.data.data.data.nameScreeningHits.length;

    }
      // console.log("Date of Birth : "+this.nameScreeningHitsData[0].screeningData.nationality[0]);
    });


    this.userService.getUserProfileNew().subscribe((data) => {
      // console.log("Profile :"+JSON.stringify(data));
      this.addedBy = data.fullName;
    });


    this.customerService.getCustomerInfoResponseById(this.mid).subscribe((res: any) => {
      this.Resultdata = res
      console.log("UserInfo DATA :", res.response.data);
      // this.status = 1;

      this.fname = res.response.data.fullName;
      this.mobile = this.mid;
      this.emailId = res.response.data.email
      this.eid = res.response.data.governmentId
      this.kycType = res.response.data.kycType;
      this.address = res.response.data.address?.street || "";
      this.documentType = res.response.data.documentType;
      this.emiratesExpiry = res.response.data.expiryDate
      this.edcMobile = res.response.data.registeredMobileNumber;
      this.nationality = res.response.data.nationality
      this.dob = res.response.data.dateOfBirth;
      this.gender = res.response.data.gender;
      this.passportNumber = res.response.data.passportNumber
      this.passportType = res.response.data.passportType;
      this.passportExpiry = res.response.data.passportExpiryDate
      this.occupation = res.response.data.occupation;
      this.pob = res.response.data.placeOfBirth;
      this.emirate = res.response.data.emirate;
      this.poBox = res.response.data.poBox;
      this.city = res.response.data.city;
      if(res.response.data.address != null){
        console.log("Address ",res.response.data.address.emirate || "")
        this.areaDesc = res.response.data.address.emirate || "";
      }

      // this.emiratesIdImage = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;charset=utf-8;base64,' +res.response.data.frontImageEmiratesId);
      // this.emiratesIdBackImage = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;charset=utf-8;base64,' +res.response.data.backImageEmiratesId);

      this.emiratesIdImage = res?.response?.data?.frontImageDocUrl;
      this.emiratesIdBackImage = res?.response?.data?.backImageDocUrl;
      this.documentInfos = res?.response?.data?.documentInfos || [];
      this.idbioLivenessResponse = res?.response?.data?.idbioLivenessResponse;
      this.idbioFaceMatchResponse = res?.response?.data?.idbioFaceMatchResponse;
      this.kycResponse = res?.response?.data?.kycResponse;
      this.icpDocumentReport = res?.response?.data?.icpDocUrl;
      this.efrDocumentReport = res?.response?.data?.efrDocUrl;
      this.uaePassEid = res?.response?.data?.emiratesIDPdfUrl;
      this.uaePassPP = res?.response?.data?.passportPdfUrl;
      this.uaePassVisa = res?.response?.data?.residenceVisaPdfUrl;
     // this.poa = res.response.data.poaDocUrl;
      this.poa = "https://uatapi.pay10.ma/product/icon/get-profile?url=user/80690dbc-c1f2-4d18-9175-abbd5be3dd90_poa.pdf&lastModified=1735892494747";

    });

  }

  activeTab = 'customerProfile'; // Default active tab
  activeTabSub='profile';


  switchTab(tab: string): void {
    this.activeTab = tab;
    this.tableVisible = true;
  }

  namePoints : any
  scoreObjectRes : any
  openScoreBreakdown(content: any,row:any,scoreObject : any) {
    console.log("Content Row : "+row);

    this.scoreObjectRes = scoreObject;

    console.log("Score Object"+this.namePoints);

    this.selectedRow = row;
    this.modalService.open(content, { centered: true });

  }

  switchTabSub(tab: string): void {
    this.activeTabSub = tab;
    this.tableVisible = false;
  }

  rowSelectProfile(item:any, nameScreeningHitsLength: Number){
    console.log("Item :"+item);
    console.log("Which row :"+nameScreeningHitsLength);
  }

  tableVisible: boolean = false; // Initially set to true to show the table

  isGenuine: boolean = false;
  isRelevant: boolean = true;
  selectedRow : number
  extraInfoObject: any ;

  toggleTableVisibility(param: RowClickedEvent | any,row : any) {
    this.tableVisible = !this.tableVisible; // Toggle visibility
    console.log("Row Clicked", param);
    console.log("Fullname : "+JSON.stringify(this.nameScreeningHitsData[row]));
    console.log("Which row selected : "+row);
    this.selectedRow = row;
    console.log("Extra Info :"+JSON.stringify(this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info));

    this.extraInfoObject = this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info;
    console.log("Extra Info :"+JSON.stringify(this.extraInfoObject));
    console.log("Designation  : "+this.nameScreeningHitsData[this.selectedRow].screeningData.role_type);
    this.associations = this.nameScreeningHitsData[row].associates;
    console.log("Associations : "+JSON.stringify(this.associations));
    this.mediaData = this.nameScreeningHitsData[row].media;
    console.log("Media : "+JSON.stringify(this.mediaData));
    this.fieldsData = this.nameScreeningHitsData[row].fields;
    console.log("Fields : "+JSON.stringify(this.fieldsData));
    for(let i:number = 0; i<this.fieldsData.length;i++){
      console.log(this.fieldsData[i]);
      for (let key in this.fieldsData[i]) {
        console.log(key);
      }
    }


  }

  async viewImageDocModal(reportType : any){
    if(reportType == "Front"){
      this.imageFile = this.emiratesIdImage;
    }else if(reportType == "Back"){
      this.imageFile = this.emiratesIdBackImage;
    }

    this.BlockedmerchantSelectEvent.emit({
              uuid : this.userId,
              mobile: this.mobile,
              encryptedUrl: this.imageFile,
              type : reportType
            });
    return await this.modalKycReportComponent.open();
  }


  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalKycReportComponent.close();
    }
  }

  openReportModal(reportType : any){
    if(reportType == "ICP"){
      this.image = this.icpDocumentReport;
    }else if(reportType == "EFR"){
      this.image = this.efrDocumentReport;
    }else if(reportType == "UAE_Pass_Emirates_ID"){
      this.image = this.uaePassEid;
    }else if(reportType == "UAE_Pass_Passport"){
      this.image = this.uaePassPP;
    }else if(reportType == "UAE_Pass_Visa"){
      this.image = this.uaePassVisa;
    }
    this.modalReportComponent.open();
  }
  downloadReportModal(reportType:any){
    if(reportType == "ICP"){
      this.image = this.icpDocumentReport;
    }else if(reportType == "EFR"){
      this.image = this.efrDocumentReport;
    }else if(reportType == "UAE_Pass_Emirates_ID"){
      this.image = this.uaePassEid;
    }else if(reportType == "UAE_Pass_Passport"){
      this.image = this.uaePassPP;
    }else if(reportType == "UAE_Pass_Visa"){
      this.image = this.uaePassVisa;
    }
    if (this.image !=null) {
      const fileName = this.fname+'_'+reportType+'_KYC_Report.pdf';
      this.http.get(this.image, { responseType: 'blob' }).subscribe((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        this.loading = false
      });
    } else {
      this.mindatadis = false;
      this.loading = false
    }
  }

saveRemarks(item: any, length: any) {
      const radioElement = document.querySelector('input[name="nshRadio' + length + '"]:checked') as HTMLInputElement;
      const relevancy = radioElement ? radioElement.value : null;

      const remarksElement = document.querySelector('input[name="remark' + length + '"]') as HTMLInputElement;
      const remarks = remarksElement ? remarksElement.value : null;

      if (remarks === "" || remarks === null || remarks.trim() === "") {
        this.alertService.toastErrorMessageAlert({titleText:"Remarks field is required"})
        return;
      }

      if (relevancy === null || relevancy === "") {
        this.alertService.toastErrorMessageAlert({titleText:"Relevancy field is required"})
        return;
      }

      if (this.saveFlag) {
        const saveRemarkIcon = document.getElementById('saveRemarkIcon' + length);
        if (saveRemarkIcon) {
          saveRemarkIcon.setAttribute('data-disabled', 'true');
        }

        console.log("Relavancy: " + relevancy);
        console.log("Comment: " + remarks);

        let requestForm = {
          "screeningId": this.screeningId,
          "mobileNumber": this.mid,
          "relevancy": relevancy,
          "remark": remarks,
          "referenceId": item._id,
          "addedBy": this.addedBy
        };

        this.customerService.saveNameScreeningRemark(requestForm).subscribe((data: any) => {
          console.log("Response" + JSON.stringify(data));
          if (data.response.message === "Name Screening Remark saved successfully") {
            Swal.fire('Name Screening Remark saved successfully', '', 'success');
            this.customerService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
              console.log("Name Screening Remark Length : "+res.response.data.length);
              this.getSavedNameScreeningLength=res.response.data.length;
            });
          } else {
            Swal.fire('Error while saving Name Screening Remark', '', 'error');
          }
        });
      } else {
        console.log("No data to be saved for name screening remark");
      }
    }

  saveActivityTimeline(screeningId:any,fullname:any,narration:any,type:any,addedBy:any){
    let requestForm ={
      "screeningId" : screeningId,
      "fullName" : fullname,
      "narration" : narration,
      "type" : type,
      "addedBy" : addedBy,
  }

    this.customerService.saveActivityTimeline(requestForm).subscribe((data) => {
      console.log("Response" + JSON.stringify(data));
      // this.alertService.successAlert(data);
    }
    );
  }

  updateReviewKycFlag(flag:any,userId:any){
    this.customerService.updateReviewFlag(flag,userId).subscribe((data) => {
      console.log("updateReviewFlag" +data);
      this.ngOnInit();
      this.selectedTab = 2;
    }
    );

  }

  kycComment:string
  selectedStatus: any
  narrationKyc:any
  typeKyc:any
  userType :any;

  submitKycReview(){
    console.log("Status :"+this.selectedStatus);
    console.log("Comment :"+this.kycComment);

    if(this.selectedStatus!=undefined && this.kycComment!=undefined && this.kycComment!= ""){
      debugger;
      if(this.reviewFlag==0 || this.reviewFlag==1 ){
        this.userType = "L1 (Maker)";
      }
      else{
        this.userType = "L2 (Checker)";
      }
      console.log("Review Flag : "+this.reviewFlag);
      if(this.selectedStatus == "ACCEPTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.userId,
          "status" : "APPROVED",
          "remark" : this.kycComment
        }
        this.customerService.updateCustomerKycStatusChange(statusChangeRequest).subscribe((data) => {
          console.log(data);
        });
      }else if(this.selectedStatus == "REJECTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.userId,
          "status" : "REJECTED",
          "remark" : this.kycComment
        }
        this.customerService.updateCustomerKycStatusChange(statusChangeRequest).subscribe((data) => {
          console.log(data);
        });

      }
    this.narrationKyc = this.userType+" Submitted Screening Review Status and changed KYC Status to "+this.selectedStatus+" with the following comment : "+this.kycComment,

    this.typeKyc = "System Generated";

    this.updateReviewKycFlag(this.saveReviewFlag,this.userId);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narrationKyc,this.typeKyc,this.addedBy);
    this.modalService.dismissAll();
    this.alertService.successAlert("Screening Review Submitted Succsessfully");
    }


  }

  get isMaxLengthExceeded(): boolean {
    return this.kycComment.length > 255;
  }

  toggleTableVisibility1(){
    this.tableVisible = !this.tableVisible;

  }



keys(): Array<string> {
  if(this.extraInfoObject){
    return Object.keys(this.extraInfoObject);
  }else{
    return []
  }
}

keyword(obj : any): Array<string> {
  console.log(JSON.parse(obj));
  if(obj)
    console.log(Object.keys(JSON.parse(obj)));

  if(obj){
    return Object.keys(JSON.parse(obj));
  }else{
    return []
  }
}



  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }

  getIconFromString(val: String){

    // console.log(val);
    if(val == "sanction"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }

  getIconFromBoolean(val: String){

    // console.log(val);
    if(val =="true"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }

  getIconFromStringCondition(val: String){

    // console.log(val);
    if(val == "false"){
      return "feather icon-check";
    }else{
    return "feather icon-x-circle";
    }
  }

  toggleRelevance(isRelevant: boolean) {
    this.isRelevant = isRelevant;
  }

  toggleGenuine() {
    this.isGenuine = !this.isGenuine;
  }


  showInitiatePop(cont: any){

    this.modalService.open(cont, { centered: true });

  }
  getSavedNameScreeningLength:any;
  showKycPop(cont:any){
    if(this.getSavedNameScreeningLength==this.nameScreeningHitsLength){
      this.modalService.open(cont, { centered: true });
    }else{
      Swal.fire('Please select relevancy for all alerts before submitting the review.',"", 'warning');
    }
  }

  narration:any
  type:any
  userType1:any;

  showInitiate(cont: any){


    this.type = "System Generated";
    if(this.reviewFlag==0 || this.reviewFlag==1 ){

      this.userType1 = "L1 (Maker)";
    }else{
      this.userType1 = "L2 (Checker)";
    }
    this.narration = "Initiated "+this.userType1+" Review Process";

    this.updateReviewKycFlag(this.saveReviewFlag,this.userId);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narration,this.type,this.addedBy)
    this.modalService.dismissAll(cont);
    // this.isShowInitiate=true;
    // console.log("name screening length : "+this.nameScreeningHitsLength);
    // for (let i = 0; i < this.nameScreeningHitsLength; i++) {
    //   debugger
    //   const saveRemarkIcon = document.getElementById('saveRemarkIcon' + i);
    //   if (saveRemarkIcon) {
    //      saveRemarkIcon.setAttribute('data-disabled', 'false');
    //     }
    // }
    this.alertService.successAlert("Screening Review Initiated Succsessfully");
  }
  hideInitiate(){
    this.isShowInitiate=false;
  }

  activityLength :any
  activityData :any
  reversedList: Array<any> = [];

  getActivityTimeline(screeningId:any){
    if(screeningId != null)
    this.customerService.getCustomerActivityById(screeningId).subscribe((data:any) => {
      console.log("Activity Response" + JSON.stringify(data));
      this.activityLength = data.response.data.length;
      console.log("activityLength" + this.activityLength);
      this.activityData = data.response.data;
      this.reversedList = this.activityData.slice().reverse();


      // console.log("activityLengthData" + this.activityData[0].addedBy);


    }
    );

  }

  getFormattedDate(epochMilli:any) {
    var d = new Date(0);
    d.setUTCMilliseconds(epochMilli);
    // console.log(d.toISOString().slice(0,10))
    return d.toISOString().slice(0,10)
  }

  showKeywordModal(cont:any,keyword : any){
    var dummmy = keyword[0];
    this.keywordList = [];
    console.log(dummmy);
    this.keywordList = dummmy.split(",");
    console.log(this.keywordList);
    this.modalService.open(cont, { centered: true });
  }

  // frontImageDocUrl/backImageDocUrl is a generic placeholder; actual CNIE scans live in documentInfos
  viewCnieDocument(documentType: 'CIN_FRONT' | 'CIN_BACK', title: string): void {
    const doc = this.documentInfos.find((d) => d.documentType === documentType);
    const path = doc?.documentPath;
    if (!path) {
      this.alertService.toastWarringMessageAlertWithMessage(`${title} is not available`);
      return;
    }

    this.http
      .get(`${environment.API_URLBLAZE}/user/files/download`, {
        params: { path },
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response) => {
          const serverType = response.headers.get('Content-Type') ?? '';
          const ext = path.split('.').pop()?.toLowerCase() ?? '';
          const contentType =
            serverType && !serverType.toLowerCase().startsWith('application/octet-stream')
              ? serverType
              : MIME_BY_EXT[ext] ?? 'application/pdf';

          const blob = new Blob([response.body as BlobPart], { type: contentType });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const modalRef = this.modalService.open(DocumentViewerModalComponent, {
              size: 'xl',
              centered: true,
            });
            modalRef.componentInstance.dataUrl = reader.result as string;
            modalRef.componentInstance.title = title;
            modalRef.componentInstance.isImage = contentType.startsWith('image/');
            modalRef.componentInstance.contentType = contentType;
          };
        },
        error: () => {
          this.alertService.errorAlert({ html: `Unable to load ${title}. Please try again.` });
        },
      });
  }

  downloadFrontImage() {
    this.http.get(this.emiratesIdImage, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        debugger
        // Create an object URL from the Blob
        const objectUrl = URL.createObjectURL(blob);
        debugger
        // Sanitize the object URL before using it
        // this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = 'emirates_id_front.png';  // Name for the downloaded front image
        link.click();
        // console.log('Blob URL:', objectUrl);
      },
      error => {
        console.error('Error fetching image:', error);
      }
    );
    // const imageBlob = this.dataURItoBlob(this.getImageFromUrl(this.emiratesIdImage));
    // const imageUrl = URL.createObjectURL(imageBlob);
    // const link = document.createElement('a');
    // link.href = imageUrl;
    // link.download = 'emirates_id_front.png';  // Name for the downloaded front image
    // link.click();
  }

uploadKycDoc(){
    this.kycUploadModal.open();
  }




  downloadBackImage() {
    this.http.get(this.emiratesIdBackImage, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        debugger
        // Create an object URL from the Blob
        const objectUrl = URL.createObjectURL(blob);
        debugger
        // Sanitize the object URL before using it
        // this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = 'emirates_id_back.png';  // Name for the downloaded front image
        link.click();
        // console.log('Blob URL:', objectUrl);
      },
      error => {
        console.error('Error fetching image:', error);
      }
    );
    // const imageBlob = this.dataURItoBlob(this.getImageFromUrl(this.emiratesIdImage));
    // const imageUrl = URL.createObjectURL(imageBlob);
    // const link = document.createElement('a');
    // link.href = imageUrl;
    // link.download = 'emirates_id_front.png';  // Name for the downloaded front image
    // link.click();

  // Function to download the back image
  // downloadBackImage() {
  //   const imageBlob = this.dataURItoBlob(this.getImageFromUrl(this.emiratesIdBackImage));
  //   const imageUrl = URL.createObjectURL(imageBlob);
  //   const link = document.createElement('a');
  //   link.href = imageUrl;
  //   link.download = 'emirates_id_back.png';  // Name for the downloaded back image
  //   link.click();
  }

  // Helper method to extract image source from the DomSanitizer safe URL
  private getImageFromUrl(sanitizedUrl: any): string {
    return sanitizedUrl.changingThisBreaksApplicationSecurity;
  }

  // Helper method to convert dataURI (base64) to Blob
  private dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);  // Decode base64 string
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uintArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([uintArray], { type: 'image/png' });  // Return Blob object
  }

  downloadFileService(docname: any, docpath: any) {
    let fileType = docname.split('.').pop();
    let fileInitial = docname.split('.')[0]
    const formData = new FormData();
    formData.append('urlfile', docpath);
    formData.append('docname', docname);
    this.customerService.downloadKycFile(formData)
      .subscribe((res: any) => {
        const response = res;
        const random = Math.floor(Math.random() * 10000000000 + 1);

        const today = new Date();

        const linkSource = 'data:application/' + fileType + ';base64,' + response.Data;
        const downloadLink = document.createElement("a");
        const NewfileName = "Merchant_Doc_" + today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) +"-"+ ("0" + today.getDate()).slice(-2) + "-" + random.toString().slice(-4) + fileInitial + "." + fileType;

        downloadLink.href = linkSource;
        downloadLink.download = NewfileName;
        downloadLink.click();
      })

  }
  kycFileSrc: any;

  viewFileService(docname: any, docpath: any) {

    let fileType = docname.split('.').pop();
    let fileInitial = docname.split('.')[0];

    const formData = new FormData();
    formData.append('urlfile', docpath);
    formData.append('docname', docname);

    return new Promise((resolve, reject) => {
      this.customerService.downloadKycFile(formData)
        .subscribe((res: any) => {
          const sizeInBytes = 4 * Math.ceil((res?.Data?.length / 3)) * 0.5624896334383812;
          const sizeInKb = sizeInBytes / 1000;
          console.log(sizeInKb, this.detectBrowserName(), "======++++++++++++===>");

          if (!res?.Data) {
            return reject(res);
          }

          // Convert the data to base64 format
          const linkSource = 'data:application/' + fileType + ';base64,' + res?.Data;
          let temp_url;

          // If file size is large, use Blob for better performance
          if (sizeInKb > 1024) {
            const blob = this.dataURLtoBlob(linkSource);
            temp_url = window.URL.createObjectURL(blob);
          }

          // Handle file type: PDF or image
          if (fileType === 'pdf') {
            // If the file is a PDF, set its source in an iframe
            this.kycFileSrc = {
              type: 'FILE', // For PDF files, we use 'FILE'
              src: this.sanitizer.bypassSecurityTrustResourceUrl(temp_url || linkSource)
            };
          } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileType)) {
            // If the file is an image, set its source in an img tag
            this.kycFileSrc = {
              type: 'IMAGE', // For images, we use 'IMAGE'
              src: this.sanitizer.bypassSecurityTrustResourceUrl(temp_url || linkSource)
            };
          } else {
            // If the file type is unknown, handle it accordingly
            this.kycFileSrc = {
              type: 'UNKNOWN',
              src: null
            };
          }

          return resolve(this.kycFileSrc);
        }, (error) => {
          return reject(error);
        });
    });
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  dataURLtoBlob(dataurl: string) {
    let arr = dataurl.split(',') || [];
    // @ts-ignore
    let mime = arr[0]?.match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
  }






  onPoaFileChange(poa : any){
      console.log("Choose File Clicked");
      var file = poa.target.files[0];
      console.log(file.size);
      if(file.size > 50000){
        console.log("Greater than 50 KB");
        Swal.fire('Icon size cannot be greater than 50 KB','','error');
        return;
      }
      poa.target.value = '';
   // poa : "image"
//userId : "153536327627"
//formData
    }


  viewKycDoc() {
  this.poa = "https://uatapi.pay10.ma/product/icon/get-profile?url=user/80690dbc-c1f2-4d18-9175-abbd5be3dd90_poa.pdf&lastModified=1735892494747";
  const fileUrl = this.poa;

  const urlParams = new URLSearchParams(new URL(fileUrl).search);
  const fileName = urlParams.get('url')?.split('/').pop();

  if (fileName) {
    if (fileName.toLowerCase().endsWith('.pdf')) {
      this.kycFileSrc = {
        src: fileUrl,
        type: 'PDF'
      };
    } else if (fileName.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
      this.kycFileSrc = {
        src: this.getSafeUrl(fileUrl),
        type: 'IMAGE'
      };
    } else {
      this.kycFileSrc = null;
    }
  } else {
    this.kycFileSrc = null;
  }

  if (this.kycFileSrc) {
    this.kycFileViewModal.open();
  }
}

getSafeUrl(url: string): SafeResourceUrl {
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}



  // Download the file
  downloadFile() {
    if (this.kycFileSrc) {
      const link = document.createElement('a');
      link.href = this.kycFileSrc.src;
      link.download = 'kyc-file'; // Default name for download
      link.click();
    }
  }

  getCountryNames(data: any): string {
    const countries = data?.screeningData?.country;
    if (!countries || !Array.isArray(countries) || countries.length === 0) {
      return 'N/A';
    }

    const names = countries
      .map((c: any) => c?.name)
      .filter((name: string | null | undefined) => !!name);

    return names.length > 0 ? names.join(', ') : 'N/A';
  }

  /**
   * Unmask all PII fields in the form
   */
  unmaskAllPiiFields(): void {
    this.piiFormService.unmaskAllFields(this.userId || 'unknown', 'customer');
  }

}

